interface LoadingSpinnerProps {
  sm?: boolean;
  text?: boolean;
  color?: string;
}

const textsData = {
  en: "Loading",
  es: "Cargando",
};

export const LoadingSpinner = ({ sm = false, text = false, color }: LoadingSpinnerProps) => {
  const bars = Array.from({ length: sm ? 4 : 8 }, (_, i) => i);
  const barColor = color ?? "#4a90e2";

  return (
    <div className="flex flex-col items-center justify-center">
      <div
        className="flex justify-center items-center box-border"
        style={{ height: sm ? "18px" : "50px" }}
      >
        {bars.map((_, index) => (
          <div
            key={index}
            className="mx-0.5"
            style={{
              width: sm ? "3px" : "4px",
              height: sm ? "20px" : "30px",
              backgroundColor: barColor,
              animation: "wave 1s infinite",
              animationDelay: `${index * 0.1}s`,
            }}
          />
        ))}
      </div>
      {text && <span>{textsData.en}</span>}
      <style>{`
        @keyframes wave {
          0% {
            transform: scaleY(0.1);
          }
          50% {
            transform: scaleY(1);
          }
          100% {
            transform: scaleY(0.1);
          }
        }
      `}</style>
    </div>
  );
};